module.exports = __webpack_public_path__ + "img/medium.24ad47ba.svg";